import { Cliente } from './../../models/cliente';
import { TokenService } from './../../servicios/token.service';
import { AuthService } from './../../servicios/auth.service';
import { AlertController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-custom-profile2',
    templateUrl: './custom-profile2.component.html',
    styleUrls: ['./custom-profile2.component.scss'],
    standalone: false
})

export class CustomProfile2Component implements OnInit {

    @Input() user: any;
    @Input() list: any;
    cliente: Cliente;

    constructor( public alertController: AlertController, public authService: AuthService,
      public tokenService: TokenService, private router: Router) {}

    misDatos(): void{
        this.router.navigate(['/misdatos/' + this.tokenService.getUserName()]);//+ this.TokenService.getUserName()])
    }

    pass(): void {
        this.router.navigate(['/pass/' ]);
    }

    esta(): void {
        this.router.navigate(['/estacionamiento/' ]);
    }

    ngOnInit() {
      this.cliente =  JSON.parse(sessionStorage.getItem('datos') || '{}');
    }

    cargaralpha(): boolean{
        if (environment.club === 'alpha') {
        return true;
        }
    }

    cargacimera(): boolean{
        if (environment.club === 'cimera') {
        return true;
        }
    }

    cargarsports(): boolean{
        if (environment.club === 'sports') {
        return true;
        }
    }
}
